webpackJsonp([319],{

/***/ 1036:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.2.1Rc.6 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1851:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1036),
  /* template */
  __webpack_require__(2136),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.2.1-rc.6-226.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.2.1-rc.6-226.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-34033694", Component.options)
  } else {
    hotAPI.reload("data-v-34033694", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2136:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.2.1Rc.6 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 slot:inline-desc")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] display-format 支持 names 作为第二个参数")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 popup 类名丢失问题")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持 prop:show-mask 隐藏遮罩")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持 prop:position 设定位置")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持 prop:width 设定左右位置时的宽度")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/scroller.html"
    }
  }, [_vm._v("Scroller")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持滚动到底部时触发事件 on-scroll-bottom")]), _vm._v(" "), _c('li', [_vm._v("[fix] 禁止点击事件触发，修复 pc 上触发两次的问题")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/selector.html"
    }
  }, [_vm._v("Selector")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 placeholder 逻辑问题. #1273")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-address.html"
    }
  }, [_vm._v("XAddress")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持属性  display-format")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-textarea.html"
    }
  }, [_vm._v("XTextarea")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 标签上对齐")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持属性  prop:autosize 自动更新高度")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34033694", module.exports)
  }
}

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1851);

/***/ })

});


// WEBPACK FOOTER //
// 319.74369663.js